import { render } from "./notice.vue?vue&type=template&id=07680394"
import script from "./notice.vue?vue&type=script&lang=js"
export * from "./notice.vue?vue&type=script&lang=js"

import "./notice.vue?vue&type=style&index=0&id=07680394&lang=css"
script.render = render

export default script